import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface ImpressionsIconProps {
  size?: number
  color?: string
  className?: string
  onClick?: () => void
}

const ImpressionsIcon: React.FC<ImpressionsIconProps> = ({
  size = 24,
  color = colors.PRIMARY,
  className,
  onClick,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path
        d='M17.09 5.27575C16.39 4.24575 15.59 3.28575 14.69 2.42575C14.34 2.08575 13.75 2.40575 13.85 2.88575C14.04 3.82575 14.24 5.06575 14.24 6.17575C14.24 8.23575 12.89 9.90575 10.83 9.90575C9.29 9.90575 8.03 8.97575 7.48 7.64575C7.38 7.44575 7.34 7.32575 7.28 7.10575C7.17 6.68575 6.62 6.55575 6.38 6.92575C6.2 7.19575 6.03 7.46575 5.87 7.75575C4.68 9.79575 4 12.1757 4 14.7157C4 19.1357 7.58 22.7157 12 22.7157C16.42 22.7157 20 19.1357 20 14.7157C20 11.2257 18.92 7.98575 17.09 5.27575ZM11.71 19.7157C9.93 19.7157 8.49 18.3157 8.49 16.5757C8.49 14.9557 9.54 13.8157 11.3 13.4557C12.77 13.1557 14.28 12.5257 15.33 11.5357C15.61 11.2757 16.07 11.3957 16.15 11.7657C16.38 12.7857 16.5 13.8457 16.5 14.9157C16.51 17.5657 14.36 19.7157 11.71 19.7157Z'
        fill={color}
      />
    </svg>
  )
}

export default ImpressionsIcon
